import React from 'react';
import Layout from "../../components/Layout";
import {Button, Form} from "react-bootstrap";

const NewsRegister = () => {
    return (
        <Layout>
            <Form className='d-flex flex-column align-items-center'>
                <Form.Group required className="mb-3" controlId="formGroupEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control required type="email" placeholder="Enter email" />
                </Form.Group>
                <Form.Group  className="mb-3" controlId="formGroupPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control required type="password" placeholder="Password" />
                </Form.Group>
                <Form.Group  className="mb-3" controlId="formGroupPassword">
                    <Form.Label>Confirm password</Form.Label>
                    <Form.Control required type="password" placeholder="Password" />
                </Form.Group>
                <Button type="submit" className='btn' variant="success">Sign up</Button>
            </Form>
        </Layout>
    );
};

export default NewsRegister;